import * as _ from 'lodash';
import { api } from '../axiosConfig';
import {
    redemptionMode, 
    redemptionRespondentRequestURL
} from '../Utils/urls';


export class RedemptionModeAPI {
    static async createRedemption(
        payload: { [key: string]: any },
    ): Promise<any> {
        return api.post(`${redemptionMode}/create`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static async updateRedemption(
        payload: { [key: string]: any },
        id: any,
    ): Promise<any> {
        return api.post(`${redemptionMode}/update/${id}`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static async getOneRedemption(
        id: any,
    ): Promise<any> {
        return api.post(`${redemptionMode}/getOne/${id}`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static async redemptionList(
        limit: number,
    ): Promise<any> {
        return api.post(`${redemptionMode}/getAll/${limit}`, {})
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }


    //Redemption request
    static async createRedemptionRequest(
        payload: { [key: string]: any },
    ): Promise<any> {
        return api.post(`${redemptionRespondentRequestURL}/create`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static async redemptionRequestListByUserId(
        limit: number,
        userId,
    ): Promise<any> {
        return api.post(`${redemptionRespondentRequestURL}/getAllByUserId/${userId}/${limit}`, {})
            .then((res) => {
                return _.get(res, 'data.data', []);
            });
    }

    static async manualApproved(
        payload: { [key: string]: any },
    ): Promise<any> {
        return api.post(`${redemptionRespondentRequestURL}/manualApprove`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }

    static async manualApproveFinance(
        payload: { [key: string]: any },
    ): Promise<any> {
        return api.post(`${redemptionRespondentRequestURL}/manualApproveFinance`, payload)
            .then((res) => {
                return _.get(res, 'data.data', {});
            });
    }
}
